// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__n0Eij","label":"Section_label__2Qhq8","contentWrap":"Section_contentWrap__Wup5f","footer":"Section_footer__1Yv2j","footerInner":"Section_footerInner__3CwF9"};